(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ffj-story]').forEach(story => {
      if (story.dataset.ffjReady) return;
      story.dataset.ffjReady = 'true';
      const list = story.querySelector('[data-ffj-toc]');
      if (!list) return;
      story.querySelectorAll('.ffj-body h2[id]').forEach(heading => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.replace(/^\d+\.\s*/, '');
        li.append(link); list.append(li);
      });
      if (!list.children.length) list.closest('aside').hidden = true;
      else list.closest('aside').hidden = false;
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
